import { ContactsTable } from "./Contacts";

export default function AdminLeads() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-foreground">Leads — Whitepaper</h1>
      <p className="text-sm text-muted-foreground">Visitors who downloaded the whitepaper.</p>
      <ContactsTable sourceFilter="whitepaper" />
    </div>
  );
}
